import React from 'react'
import Editor from 'react-simple-code-editor'
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism.css'
import { useDispatch, useSelector } from 'react-redux'
import { SET_SLIDE_CONTENT } from '../redux/manageSlidesReducer'
import { RootReducer } from '../redux/rootReducer'

type Props = {}

const SlideEditor = (props: Props) => {
  const dispatch = useDispatch()
  const activeSlide = useSelector((state: RootReducer) => state.manageSlidesReducer.activeSlide?.html)
  return (
    <div className="h-[500px] overflow-scroll border border-gray-300 rounded-md">
      <Editor
        textareaClassName="outline-none"
        value={activeSlide || ''}
        onValueChange={(code) => {
          dispatch(SET_SLIDE_CONTENT(code))
        }}
        highlight={(code) => highlight(code, languages.js)}
        padding={10}
        style={{
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 14,
          lineHeight: 1.5,
          borderRadius: 5,
          outline: 'none'
        }}
      />
    </div>
  )
}

export default SlideEditor
